import {Component, store} from 'Generic';
import {getIncentivePlanDetails, toggleIncentive, updateIncentiveBox} from 'Generic/lib';

export default class Incentive extends Component {
  constructor() {
    super({
      store,
      element: document.querySelector('#hidden-product-wrapper'),
      state: store.state,
    });
  }

  render() {
    let incentiveHtml = '';
    let incentivePlanDetails = getIncentivePlanDetails();

    if (incentivePlanDetails) {
      incentiveHtml = incentivePlanDetails.html;
    } else {
      let incentiveElement = document?.querySelector('#hidden-product-wrapper');
      if (incentiveElement && window.getComputedStyle(incentiveElement).display === 'block') {
        toggleIncentive(false);
      }
    }

    if (this.element?.innerHTML) {
      this.element.innerHTML = incentiveHtml;
    }

    // incentive plan and hidden packages
    updateIncentiveBox(incentivePlanDetails);
  }
}
